import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'

export const FormaDePagamento = () => {
  const { localAtendimento } = useContext(GlobalContext)
  const [refresh, setRefresh] = useState(0)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  const handleRemove = useCallback((dados) => {
    metodoPrograma('exclui', { idFormaPagamento: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlFormaDePagamento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlFormaDePagamento"
              action="lista"
              rows={10}
              onRowSelect={handleClick}
              habSearch={true}
              parametros={{ idLocalAtendimento: localAtendimento?.[0] || -1 }}
              head={['Forma de Pagamento', 'Parcelamento', 'Data Exclusão']}
              line={(item) => [
                item[1],
                item[2] === 'S' ? 'Sim' : 'Não',
                item[3],
              ]}
              collumnsDateHour={[2]}
              onDelete={{ index: 2, action: handleRemove }}
              refresh={refresh}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default FormaDePagamento
